var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,0L13,0C5.83,0,0,5.83,0,13s5.83,13,13,13c7.17,0,13-5.83,13-13C25.99,5.84,20.16,0.01,13,0z M5.23,5.23 C7.31,3.15,10.07,2.01,13,2.01h0c6.06,0,10.99,4.93,10.99,10.99C23.98,19.05,19.05,23.98,13,23.99c-2.94,0-5.69-1.14-7.77-3.22 C3.15,18.69,2.01,15.93,2.01,13C2.01,10.06,3.16,7.31,5.23,5.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.44,18.64c-0.01,0.27,0.09,0.52,0.28,0.72c0.19,0.2,0.45,0.31,0.72,0.31c0.26,0,0.52-0.1,0.73-0.3l4.74-4.74 l4.75,4.75c0.4,0.38,1.04,0.37,1.42-0.03c0.37-0.39,0.37-1-0.01-1.4l-4.74-4.74l4.74-4.74c0.39-0.39,0.39-1.03,0-1.42v0 c-0.39-0.39-1.03-0.39-1.42,0l-4.74,4.74L8.17,7.06c-0.38-0.4-1.02-0.42-1.42-0.03c-0.19,0.19-0.3,0.44-0.31,0.7 C6.43,8,6.53,8.25,6.74,8.47l4.74,4.74l-4.73,4.73C6.55,18.12,6.44,18.37,6.44,18.64z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.25bd44ca1a25708065e2fd8a86a4a05b.svg";
export { ForwardRef as ReactComponent };